import {post,get} from '../../libs/ajax.js'

// 搜索筛选
export function compareGetSearchListApi (data) {
    return post('/material/compare/get_search_list', data)
}

// 列表
export function compareGetListApi (data) {
    return post('/material/compare/get_list', data)
}

// 操作比对结果-相同
export function compareOperationSameApi (data) {
    return post('/material/compare/operation_the_same', data)
}

// 操作比对结果-不相同
export function compareOperationDiffApi (data) {
    return post('/material/compare/operation_diff', data)
}

// 批量操作比对结果-相同
export function compareBatchOperationSameApi (data) {
    return post('/material/compare/batch/operation_the_same', data)
}

// 批量操作比对结果-不相同
export function compareBatchOperationDiffApi (data) {
    return post('/material/compare/batch/operation_diff', data)
}

// 搜索玩咖素材
export function compareSearchMaterialMd5Api (data) {
    return post('/material/compare/search/material_md5', data)
}

// 搜索媒体素材
export function compareSearchPlatMd5Api (data) {
    return post('/material/compare/search/plat_material', data)
}

// 插入对比
export function compareSaveApi (data) {
    return post('/material/compare/save', data)
}

// 预览
export function comparePreviewApi (data) {
    return post('/material/compare/preview', data)
}